import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchPopup, markPopupViewed } from "./popup.service";
import { PopupResponse } from "./popup.types";
import { handleApiError } from "@/app/utils/handleApiError";

export const getPopup = createAsyncThunk<
  PopupResponse,
  void,
  { rejectValue: string }
>("popup/getPopup", async (_, { rejectWithValue }) => {
  try {
    return await fetchPopup();
  } catch (err) {
    return rejectWithValue(handleApiError(err));
  }
});

export const markPopupAsViewed = createAsyncThunk<
  void,
  number,
  { rejectValue: string }
>("popup/markAsViewed", async (popup_id, { rejectWithValue }) => {
  try {
    await markPopupViewed(popup_id);
  } catch (err) {
    return rejectWithValue(handleApiError(err));
  }
});